if (!customElements.get('pc-cart-recommendations')) {
  customElements.define('pc-cart-recommendations', class extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      this.track = this.querySelector('.pc-cart-recs__track');
      this.ids = new Set(JSON.parse(this.dataset.cartIds).map(String));
      this.querySelectorAll('[data-direction]').forEach(button => button.addEventListener('click', () => {
        this.track.scrollBy({ left: Number(button.dataset.direction) * (this.track.clientWidth + 12), behavior: 'smooth' });
      }, { signal: this.controller.signal }));
      this.track.addEventListener('scroll', () => this.updateControls(), { passive: true, signal: this.controller.signal });
      this.resizeObserver = new ResizeObserver(() => this.updateControls());
      this.resizeObserver.observe(this.track);
      this.load();
    }
    disconnectedCallback() { this.controller?.abort(); this.resizeObserver?.disconnect(); }
    updateControls() {
      const end = this.track.scrollWidth - this.track.clientWidth;
      this.querySelector('[data-direction="-1"]').disabled = this.track.scrollLeft < 2;
      this.querySelector('[data-direction="1"]').disabled = this.track.scrollLeft >= end - 2;
    }
    filterCards() {
      const seen = new Set(this.ids);
      let count = 0;
      this.track.querySelectorAll('[data-product-id]').forEach(card => {
        if (seen.has(card.dataset.productId) || count >= 4) card.remove();
        else { seen.add(card.dataset.productId); count++; }
      });
      this.hidden = count === 0;
      this.updateControls();
      return count;
    }
    async load() {
      if (this.dataset.mode === 'manual') { this.filterCards(); return; }
      // Keep requesting from other cart products when earlier ones have no eligible matches.
      for (const id of this.ids) {
        if (!this.isConnected) return;
        const url = new URL(this.dataset.url, location.origin);
        url.search = new URLSearchParams({ product_id: id, limit: '10', intent: 'related', section_id: 'pc-cart-recommendations' });
        try {
          const response = await fetch(url, { signal: this.controller.signal });
          if (!response.ok) continue;
          const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
          if (!this.isConnected) return;
          doc.querySelectorAll('.pc-cart-recs__card').forEach(card => this.track.append(card));
          if (this.filterCards() >= 4) break;
        } catch (error) { if (error.name === 'AbortError') return; }
      }
    }
  });
}
